$(function() {

  if(window.location.hash) {
    $('#tabs-nav li:last-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:last').show();
  } else {
    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();
  }



// Click function
$('#tabs-nav li .tab-toggle').click(function(){
  $('#tabs-nav li .tab-toggle').removeClass('active');
  $(this).addClass('active');
  $('.tab-toggle__content').hide();
  
  $(this).closest('.tab-toggle__content').slideToggle();
  return false;
});


$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

var onresize = function() {
  width = document.body.clientWidth;

  if (width > 768) {
    // Show the first tab and hide the rest
    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();
      
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });
  }
}

const classes = {
  buttonToggle: '.tab-toggle',
  parentElement: '.tab-content',
  toggleContent: '.tab-toggle__content'
}

const collapseContent = (e) => {
  width = document.body.clientWidth;
  if (width <= 767) {
    const target = e.currentTarget;
    const tabContainer = target.closest(classes.parentElement);
    if (tabContainer.classList.contains('open')) {
      tabContainer.classList.remove('open');
    } else {
      tabContainer.classList.add('open');
    }
  }
}


document.querySelectorAll(classes.buttonToggle).forEach(e => {
  e.addEventListener('click', collapseContent);
});

$(".product-carousel-wrapper-slider").slick({
    // normal options...
    infinite: true,
    arrows: true,
    dots: false,
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-arrow slick-prev"></div>',
    nextArrow: '<div class="slick-arrow slick-next"></div>',
    asNavFor: '.product-carousel-nav-slider'
});

$(".product-carousel-nav-slider").slick({
    // normal options...
    infinite: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    rows: 0,
    asNavFor: '.product-carousel-wrapper-slider',
    focusOnSelect: true,
    speed: 500,
    vertical: true,
    verticalSwiping: true,
    cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
    prevArrow: '<div class="slick-arrow slick-prev"></div>',
    nextArrow: '<div class="slick-arrow slick-next"></div>',
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
            }
        }
    ]
});

$(".prod-usps--slider ul").slick({
  infinite: true, 
  arrows: true, 
  dots: false, 
  slidesToShow: 1, 
  slidesToScroll: 1, 
  autoplay: true, 
  autoplaySpeed: 5000, 
  mobileFirst: true,
  prevArrow: '<div class="slick-arrow slick-prev"></div>',
  nextArrow: '<div class="slick-arrow slick-next"></div>'
})

var modal = document.getElementById("sizeGuideModal");
var btn = document.getElementById("size-guide-modal");
var span = document.getElementsByClassName("close")[0];

$(document).on('click', '#size-guide-modal', function () {
  modal.style.display = "block";
})

$(document).on('click', '.close', function () {
  modal.style.display = "none";
})

$(document).on('click', '#sizeGuideModal', function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
})

})

